import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Container, Grid, TextField } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Navbar from '../../../components/NavBar/NavBar';
import Footer from '../../../components/Footer/Footer';
import { Banner, BannerText, BannerLogo } from '../../../styles/Banner';
import { politica } from '../../../constants/Institucional/politicas';
import NavLinkItem from '../QuemSomos/NavLinksItem';

const Politica = () => {
    const [busca, setBusca] = useState('');
    const politicasFiltrados = politica.filter(p =>
        p.topico.toLowerCase().includes(busca.toLowerCase()) ||
        p.paragrafos.some(paragrafo =>
        paragrafo.toLowerCase().includes(busca.toLowerCase())
    )
    );
        return (
            <>  
                <Navbar/>
                <div>
                    <Banner>
                        <BannerText>
                        <p>
                            <a href="https://www.meucupom.com/" target='_blank' rel="noreferrer">Home</a> &gt; Institucional &gt; Política de Privacidade
                        </p>
                        <Typography variant='h2'
                        >Política de Privacidade</Typography>

                        <TextField
                            placeholder="Pesquise..."
                            variant="outlined"
                            size="medium"
                            value={busca}
                            onChange={(e) => setBusca(e.target.value)}
                            sx={{
                                mt: 2,
                                backgroundColor: "#fff",
                                borderRadius: "50px",
                                width: "100%",
                                maxWidth: {
                                    xs: 300, 
                                    sm: 400, 
                                    md: 600, 
                                },
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": { borderColor: "transparent" },
                                    "&:hover fieldset": { borderColor: "#ffcc00" },
                                    "&.Mui-focused fieldset": { borderColor: "#ffcc00" }
                                }
                            }}
                            
                        />
                            <NavLinkItem to="/institucional/termos-de-uso" label="TERMOS DE USO" />
                        </BannerText>
                        <BannerLogo>
                            <img 
                                src="https://cdn.meucupom.com/app-assets/5.07.56/novomc/assets/images/logo-negative.png" 
                                alt="MeuCupom Logo" 
                            />
                        </BannerLogo>
                    </Banner>
                    <Container maxWidth="lg" sx={{ py: 4 }}>
                        <Typography 
                        variant="h4" 
                        sx={{
                            marginBottom: '3rem',
                            fontSize: { xs: '1.8rem', sm: '2rem', md: '2.5rem' } 
                        }}>
                        Política de Privacidade
                        </Typography>
                        <Grid container spacing={2}>
                        <Grid item xs={12}>
                        {politicasFiltrados.length > 0 ? (
                            politicasFiltrados.map((politica, index) => (
                                <Accordion key={index}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel${index}-content`}
                                    id={`panel${index}-header`}
                                    sx={{
                                    minHeight: 80,
                                    '& .MuiAccordionSummary-content': {
                                        margin: '20px 0',
                                    },
                                    }}
                                >
                                    <Typography variant="h6" sx={{ textTransform: 'uppercase' }}>{politica.topico}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                {politica.paragrafos.map((p, i) => (
                                    <Typography key={i} paragraph>
                                    {p}
                                    </Typography>
                                ))}
                                </AccordionDetails>
                                </Accordion>
                            ))
                            ) : (
                            <Typography variant="body1">Nenhuma Política encontrada.</Typography>
                        )}
                            
                        </Grid>
                        </Grid>
                    </Container>
                </div>
                <Footer/>
            </>
        );
};
export default Politica;